import { CSSProperties, css, cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Button as ReakitButton } from 'reakit';
import { baseTheme, flex, theming } from 'styles/utils';
export type VariantTypes = 'primary' | 'secondary' | 'tertiary' | 'link' | 'danger' | 'dangerSecondary';
export type ButtonStateTypes = 'normal' | 'hover' | 'active' | 'disable';
export type ButtonStateStyles = Record<ButtonStateTypes, CSSProperties>;
export type ButtonStatesCustomStyles = Record<VariantTypes, ButtonStateStyles>;
export const boxShadowColor = `#1018280D`;
export const defaultButtonVariantsStyles: ButtonStatesCustomStyles = {
  primary: {
    normal: {
      color: baseTheme.light.colors.white,
      backgroundColor: baseTheme.light.colors.primary600,
      border: `1px solid ${baseTheme.light.colors.primary600}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`
    },
    hover: {
      color: baseTheme.light.colors.white,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.primary700,
      border: `1px solid ${baseTheme.light.colors.primary700}`
    },
    active: {
      color: baseTheme.light.colors.white,
      backgroundColor: baseTheme.light.colors.primary600,
      border: `1px solid ${baseTheme.light.colors.primary}`,
      boxShadow: ` 0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${baseTheme.light.colors.primary100}`
    },
    disable: {
      color: baseTheme.light.colors.white,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.primary200,
      border: `1px solid ${baseTheme.light.colors.primary200}`
    }
  },
  secondary: {
    normal: {
      color: baseTheme.light.colors.primary700,
      backgroundColor: baseTheme.light.colors.primary50,
      border: `1px solid ${baseTheme.light.colors.primary50}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`
    },
    hover: {
      color: baseTheme.light.colors.primary700,
      border: `1px solid ${baseTheme.light.colors.primary50}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.primary100
    },
    active: {
      color: baseTheme.light.colors.primary700,
      backgroundColor: baseTheme.light.colors.primary50,
      border: `1px solid ${baseTheme.light.colors.primary50}`,
      boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${baseTheme.light.colors.primary100}`
    },
    disable: {
      border: `1px solid ${baseTheme.light.colors.primary50}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      color: baseTheme.light.colors.primary300,
      backgroundColor: baseTheme.light.colors.primary25
    }
  },
  tertiary: {
    normal: {
      color: baseTheme.light.colors.gray700,
      backgroundColor: baseTheme.light.colors.white,
      border: `1px solid ${baseTheme.light.colors.gray200}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`
    },
    hover: {
      border: `1px solid ${baseTheme.light.colors.gray200}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      color: baseTheme.light.colors.gray800,
      backgroundColor: baseTheme.light.colors.gray50
    },
    active: {
      color: baseTheme.light.colors.gray700,
      backgroundColor: baseTheme.light.colors.white,
      border: `1px solid ${baseTheme.light.colors.primary50}`,
      boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${baseTheme.light.colors.gray100}`
    },
    disable: {
      border: `1px solid ${baseTheme.light.colors.gray200}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      color: baseTheme.light.colors.gray300,
      backgroundColor: baseTheme.light.colors.white
    }
  },
  link: {
    normal: {
      padding: 0,
      height: 'auto',
      color: baseTheme.light.colors.primary600
    },
    hover: {
      color: baseTheme.light.colors.primary800
    },
    active: {
      color: baseTheme.light.colors.primary700
    },
    disable: {
      color: baseTheme.light.colors.gray300
    }
  },
  danger: {
    normal: {
      color: baseTheme.light.colors.white,
      backgroundColor: baseTheme.light.colors.error600,
      border: `1px solid ${baseTheme.light.colors.error600}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`
    },
    hover: {
      color: baseTheme.light.colors.white,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.error700,
      border: `1px solid ${baseTheme.light.colors.error700}`
    },
    active: {
      color: baseTheme.light.colors.white,
      backgroundColor: baseTheme.light.colors.error600,
      border: `1px solid ${baseTheme.light.colors.error600}`,
      boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${baseTheme.light.colors.error100}`
    },
    disable: {
      color: baseTheme.light.colors.white,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.error200,
      border: `1px solid ${baseTheme.light.colors.error200}`
    }
  },
  dangerSecondary: {
    normal: {
      color: baseTheme.light.colors.error600,
      backgroundColor: baseTheme.light.colors.white,
      border: `1px solid ${baseTheme.light.colors.error600}`,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`
    },
    hover: {
      color: baseTheme.light.colors.error600,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.white,
      border: `1px solid ${baseTheme.light.colors.error700}`
    },
    active: {
      color: baseTheme.light.colors.error600,
      backgroundColor: baseTheme.light.colors.white,
      border: `1px solid ${baseTheme.light.colors.error600}`,
      boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${baseTheme.light.colors.error100}`
    },
    disable: {
      color: baseTheme.light.colors.error600,
      boxShadow: `0px 1px 2px 0px ${boxShadowColor}`,
      backgroundColor: baseTheme.light.colors.white,
      border: `1px solid ${baseTheme.light.colors.error200}`
    }
  }
};
export const getButtonStateStyles = (variant: VariantTypes): ButtonStateStyles => {
  const specificVariant = defaultButtonVariantsStyles[variant];
  const styles = {
    normal: specificVariant.normal,
    hover: specificVariant.hover,
    active: specificVariant.active,
    disable: specificVariant.disable
  };
  return styles;
};
export const StyledButton = /*#__PURE__*/styled(ReakitButton)({
  name: "StyledButton",
  class: "omponents__Button__Button_styles_tsx-StyledButton-sp5yr80",
  vars: {
    "sp5yr80-0": [({
      variant
    }) => variant === 'link' ? '0' : '10px 24px'],
    "sp5yr80-1": [({
      variant
    }) => variant === 'link' ? 'auto' : '2.125rem'],
    "sp5yr80-3": [({
      variant
    }) => variant === 'link' ? 'auto' : '2.5rem'],
    "sp5yr80-4": [({
      variant
    }) => variant === 'link' ? '0' : '0 1.1rem'],
    "sp5yr80-5": [({
      variant
    }) => variant === 'link' ? '0' : '0 0.6rem'],
    "sp5yr80-6": [({
      variant
    }) => variant === 'link' ? '0' : '0 0.7rem'],
    "sp5yr80-7": [({
      variant
    }) => (getButtonStateStyles(variant).normal.color as string) || 'inherit'],
    "sp5yr80-8": [({
      variant
    }) => (getButtonStateStyles(variant).normal.backgroundColor as string) || 'inherit'],
    "sp5yr80-9": [({
      variant
    }) => (getButtonStateStyles(variant).normal.border as string) || 'none'],
    "sp5yr80-10": [({
      variant
    }) => (getButtonStateStyles(variant).normal.boxShadow as string) || 'none'],
    "sp5yr80-11": [({
      variant
    }) => (getButtonStateStyles(variant).hover.color as string) || 'inherit'],
    "sp5yr80-12": [({
      variant
    }) => (getButtonStateStyles(variant).hover.backgroundColor as string) || 'inherit'],
    "sp5yr80-13": [({
      variant
    }) => (getButtonStateStyles(variant).hover.border as string) || 'none'],
    "sp5yr80-14": [({
      variant
    }) => (getButtonStateStyles(variant).hover.boxShadow as string) || 'none'],
    "sp5yr80-15": [({
      variant
    }) => (getButtonStateStyles(variant).active.color as string) || 'inherit'],
    "sp5yr80-16": [({
      variant
    }) => (getButtonStateStyles(variant).active.backgroundColor as string) || 'inherit'],
    "sp5yr80-17": [({
      variant
    }) => (getButtonStateStyles(variant).active.border as string) || 'none'],
    "sp5yr80-18": [({
      variant
    }) => (getButtonStateStyles(variant).active.boxShadow as string) || 'none'],
    "sp5yr80-19": [({
      variant
    }) => (getButtonStateStyles(variant).disable.color as string) || 'inherit'],
    "sp5yr80-20": [({
      variant
    }) => (getButtonStateStyles(variant).disable.backgroundColor as string) || 'inherit'],
    "sp5yr80-21": [({
      variant
    }) => (getButtonStateStyles(variant).disable.border as string) || 'none'],
    "sp5yr80-22": [({
      variant
    }) => (getButtonStateStyles(variant).disable.boxShadow as string) || 'none']
  }
});
export const loader = "omponents__Button__Button_styles_tsx-loader-l67jgrg";
export const loaderWrapper = cx("omponents__Button__Button_styles_tsx-loaderWrapper-l1a6ly2i", flex.init, flex.justifyContent.center, flex.alignItems.center);

require("./Button.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Button.styles.tsx");